import React, { useState, useEffect, useRef } from 'react';
import styles from '../CSS/AgentHome.module.css';
import '../CSS/AddMoney.css'

import { GoArrowRight } from "react-icons/go";

import { useNavigate } from "react-router-dom";
import { useAuth } from '../AuthContext';

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const AddMoney = () => {
    const navigate = useNavigate();
    const { postData, fetchData, user } = useAuth();

    let path = window.location.hash
    const getParams = path.split('?')[1]
    const query = new URLSearchParams(getParams);
    const userIdA = query.get('userId')

    const [userId, setUserId] = useState(userIdA ? userIdA : '');
    const [amount, setAmount] = useState('');
    const [type, setType] = useState('deposit')

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [list, setList] = useState([]);

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/fund/records');
            setLoader(false);

            //data.records || []
            setList(data.records || []);

        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, []);

    async function sendData() {
        setLoader(true);

        try {
            const data = await postData('/admin/add/balance', { userId, amount, type: type === 'withdraw' ? true : false });
            setLoader(false);

            setList(data.records || []);

        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }


    return (
        <div className='dashboard'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Update Balance</h1>
                </div>
                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className={styles['summary-container']}>
                <div className={styles['summary-card']}>
                    <div className={styles['button-group']}>
                        <button style={{ background: `${type === 'deposit' ? 'green' : ''}`}} onClick={() => setType('deposit')}>Deposit</button>
                        <button style={{ background: `${type === 'withdraw' ? 'green' : ''}` }} onClick={() => setType('withdraw')}>Withdrawal</button>
                    </div>

                    <div className="main-sec">
                        <div className="ms-input">
                            <div className="ms-col-title">&nbsp;User ID:</div>
                            <input type="text" placeholder='Enter user account id.' value={userId} onChange={(e) => setUserId(e.target.value)} />
                        </div>
                        <br />
                        <div className="ms-input">
                            <div className="ms-col-title">&nbsp;Amount:</div>
                            <input type="text" placeholder='Enter amount to add' value={amount} onChange={(e) => setAmount(e.target.value)} />
                        </div>

                        <button className="confirm-btn" onClick={sendData}>Add Money</button>
                    </div>
                </div>

                <div className="table-container" style={{ minWidth: '60%'}}>
                    <table>
                        <thead>
                            <tr>
                                <th>User ID</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((w, i) => (
                                <tr key={i}>
                                    <td>
                                        <div>{w.id}</div>
                                    </td>
                                    <td>
                                        <div>{w.amount}</div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default AddMoney